import { Grid, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { errorMessage } from '../../../../util/ConfirmAlertUtil';
import { dateFormat } from '../../../../util/DateUtil';
import BimestreProfileWithoutChange from '../../../Bimestre/BimestreProfileWithoutChange';
import TurmaDisciplinaProfessorProfileWithoutChange from '../../../TDP/TurmaDisciplinaProfessorProfileWithoutChange';
import Button from '../../../UI/Button';
import Loading from '../../../UI/Loading';
import { check, checkByNumeroBimestre } from '../api-cronograma-quant-aula-dia';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';
import { findByAnoLetivoAndSerieAndNumeroBimestre } from '../../../Bimestre/api-bimestre';
import { errorBg, errorBorder, successBg, successBorder } from '../../../UI/ColorUtil';

const ConferirComPresencaContainer = () => {
    const location = useLocation();
    const { tdp, numeroBimestre } = location.state;
    const [bimestre, setBimestre] = useState(location.state.bimestre);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const history = useNavigate();

    useEffect(() => {
        if (tdp && tdp.codigo && bimestre && bimestre.codigo) {
            check(tdp.codigo, bimestre.codigo).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setList(data);
                }
                setIsLoading(false);
            })
        }

    }, [tdp, bimestre]);

    useEffect(() => {
        if (tdp.codigo && numeroBimestre) {
            checkByNumeroBimestre(tdp.codigo, numeroBimestre).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setList(data);
                }
            });
            findByAnoLetivoAndSerieAndNumeroBimestre(tdp.turma.serie.codSerie, numeroBimestre).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setBimestre(data);
                }
            })
        }
    }, [tdp, numeroBimestre]);

    return (
        <Grid container spacing={3} component={Paper}
            style={{ margin: '10px', padding: "20px" }}
        >
            <Grid>
                <TurmaDisciplinaProfessorProfileWithoutChange tdp={tdp} />
            </Grid>
            {bimestre &&
                <Grid>
                    <BimestreProfileWithoutChange bimestre={bimestre} />
                </Grid>
            }
            <Grid size={12}>
                <Button
                    onClick={() => history(-1)}
                    variant="contained"
                    color="secondary"
                >
                    <ArrowBackIcon style={{ marginRight: '10px' }} />
                    Voltar
                </Button>
            </Grid>
            <Grid size={12}>
                <Typography variant='h5'>
                    Conferência Cronograma - Presença
                </Typography>
            </Grid>
            <Grid size={12}>
                {isLoading ? <Loading /> :
                    <Grid container spacing={2} direction='row'>
                        {list.map((ccp, index) => (
                            <Grid
                                key={index}
                                style={{
                                    backgroundColor: ccp.isCorrect ? successBg : errorBg,
                                    borderRadius: '20px',
                                    borderStyle: 'solid',
                                    borderColor: ccp.isCorrect ? successBorder : errorBorder,
                                    borderWidth: '5px',
                                    margin: '10px',
                                    padding: '10px',
                                }}
                                size={3}>
                                <Grid
                                    container
                                    spacing={2}
                                    direction='column'
                                    style={{ textAlign: 'center' }}
                                >
                                    <Grid>
                                        <Typography variant='body'>
                                            Data: {dateFormat(ccp.data)}
                                        </Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography variant='body'>
                                            {ccp.message}
                                        </Typography>
                                    </Grid>


                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                }
            </Grid>
        </Grid>
    );
}

export default ConferirComPresencaContainer;